import { EntidadeBase } from 'hay-core-react';
class ConfiguracaoModel extends EntidadeBase {
    constructor() { super('configuracao'); }
}

const instance = new ConfiguracaoModel();
export default instance;
